import dayjs from 'dayjs'
import ptBr from 'dayjs/locale/pt-br'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { api } from "../../api/services/axios"

dayjs.extend(localizedFormat)
dayjs.locale(ptBr)

export async function useGetMetrics(artigoIds, setMetricasPaginadas, setMetricasFiltradas, setIsLoading, paginaAtual = 1, tamanhoDaPagina = 5) {
    setMetricasFiltradas([])
    setIsLoading(true)
    const parametros = {
        PaginaAtual: paginaAtual,
        TamanhoDaPagina: tamanhoDaPagina,
        ArtigoIds: artigoIds
    }

    api.defaults.headers['Authorization'] = `Bearer ${sessionStorage.getItem('access_token')}`
    api.options.content
    await api.post(`/plugin/artigos/metricas-paginadas`, parametros, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => {
            setMetricasPaginadas(res?.data)
        })

    setIsLoading(false)
}    